import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
export const inventorySlice = createSlice({
  name: "inventoryState",
  initialState: {
    showNewInventoryModal: false,
    showAddNames: false,
    showPrintQrCodeModal: false,
    showCreateRoomsInventory: false,
    namesAdditionType: "beneficiaries", // it could be  beneficiaries  ||  use_places
    items: [],
    initialData: [],
    newItems: [],
    printType: "QrCode", // "InventorySheet"
  },
  reducers: {
    setShowCreateRoomsInventory: (state, action) => {
      state.showCreateRoomsInventory = action.payload;
    },
    setShowPrintQrCodeModal: (state, action) => {
      const { bool, type } = action.payload;
      state.showPrintQrCodeModal = bool;
      state.printType = type;
    },
    showAddNamesModal: (state, action) => {
      state.showAddNames = true;
      state.namesAdditionType = action.payload;
    },
    hideAddNamesModal: (state) => {
      state.showAddNames = false;
    },
    showNewInventoryModal: (state) => {
      state.showNewInventoryModal = true;
    },
    hideNewInventoryModal: (state) => {
      state.showNewInventoryModal = false;
    },
    removeInventoryItem: (state, action) => {
      const { inventoryCode } = action.payload;
      state.newItems = _.filter(
        state.newItems,
        (item) => item.inventoryCode != inventoryCode
      );
    },
    deleteInventoryItem: (state, action) => {
      const { id } = action.payload;
      const deleted = _.filter(
        state.initialData,
        (item) => item.inventory_item_id != id
      );
      state.initialData = deleted;
      state.items = deleted;
    },
    setInitialData: (state, action) => {
      state.initialData = action.payload;
    },
    setInventoryItems: (state, action) => {
      state.items = action.payload;
    },
    addNewItem: (state, action) => {
      state.newItems = [...state.newItems, action.payload];
    },
  },
});
export const {
  showAddNamesModal,
  hideAddNamesModal,
  showNewInventoryModal,
  hideNewInventoryModal,
  removeInventoryItem,
  setInitialData,
  setInventoryItems,
  addNewItem,
  deleteInventoryItem,
  setShowPrintQrCodeModal,
  setShowCreateRoomsInventory,
} = inventorySlice.actions;
export default inventorySlice.reducer;
